import { IonContent } from '@ionic/react';
import React from 'react';

import { S3_BUCKET_URL } from '@/constants';
import { amplitudeModule } from '@/modules/amplitude';
import { LogoWithAppName } from '@/pages/Onboarding/components/LogoWithAppName';
import { useOnboarding } from '@/pages/Onboarding/context';
import { canLogEvents } from '@/utils/canLogEvents';

import {
  PageStyles,
  PageTitleStyles,
  PageSubtitleStyles,
  BottomButtonStyles,
  SubtitleStyles,
  MainImageStyles,
  TopImageStyles,
} from './WelcomeScreen.styles';

export const WelcomeScreen: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'WelcomeScreen',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const handleNextStep = () => {
    wizard.nextStep();
  };

  return (
    <PageStyles>
      <TopImageStyles>
        <img
          src={`${S3_BUCKET_URL}/layout-own-ai-constructor/welcome/characters-top.png`}
          alt="Young couple"
        />
      </TopImageStyles>
      <IonContent>
        <MainImageStyles>
          <img
            src={`${S3_BUCKET_URL}/layout-own-ai-constructor/welcome/characters.png`}
            alt="Young couple"
          />
        </MainImageStyles>
        <div className="content-wrapper">
          <LogoWithAppName className="app-logo" withCaption={false} />
          <PageTitleStyles
            className="page-title"
            component="h1"
            variant="headline-large"
            align="center"
          >
            Create Your Perfect
            <br />
            <PageSubtitleStyles
              variant="inherit"
              color="gradient"
              component="span"
              className="page-subtitle"
            >
              One Night Stand Story
            </PageSubtitleStyles>
            <SubtitleStyles>
              Design your ideal partner, choose the setting,
              <br />
              and live a night to remember.
            </SubtitleStyles>
          </PageTitleStyles>
          <BottomButtonStyles
            size="large"
            round="md"
            onClick={handleNextStep}
            expand="full"
          >
            Start Building
          </BottomButtonStyles>
        </div>
      </IonContent>
    </PageStyles>
  );
};
